export const version = {Version: "1.0.5", dateBuild: "12/10/2025"}